import axios from "axios";

export const updatePort = async (item, id) => {
  try {
    const config = {
      withCredentials: true,
      headers: {
        withCredentials: true,
      },
    };
    const port_data = {
      port_no: item.port_no,
      port_name: item.port_name,
      sales_person_id:item.sales_person_id,
      sales_person_full_name:item.sales_person_full_name,
    };

    const data = await axios.post(
      `${process.env.REACT_APP_URL}/api/port-master/update-port-master?id=${id}`,
      port_data,
      config
    );
    return data;
  } catch (error) {
    return error?.response?.data;
  }
};
